import { TaskCenterTypes, useGetTasksWithFilters } from '@frontend/api-task-center';
import { useTaskCenterStore } from '../provider';
import { getTaskCenterQueryKeys } from '../utils';

export const useGetTasks = (status: TaskCenterTypes.TaskStatus) => {
  const { locationIds, selectedFilters, assigneeFilter } = useTaskCenterStore([
    'locationIds',
    'selectedFilters',
    'assigneeFilter',
  ]);
  const queryKeys = getTaskCenterQueryKeys(status);

  const sortType = selectedFilters.sortType;

  const filter: Record<number, TaskCenterTypes.Filter> = {
    [TaskCenterTypes.FilterType_index.FILTER_BY_LOCATION]: { locationId: locationIds },
    [TaskCenterTypes.FilterType_index.FILTER_BY_STATUS]: { locationId: locationIds, status: [status] },
  };

  if (selectedFilters.source) {
    filter[TaskCenterTypes.FilterType_index.FILTER_BY_SOURCE] = {
      locationId: locationIds,
      source: selectedFilters.source,
    };
  }

  if (selectedFilters.createdBy) {
    filter[TaskCenterTypes.FilterType_index.FILTER_BY_AUTHOR] = {
      locationId: locationIds,
      createdBy: selectedFilters.createdBy,
    };
  }
  if (assigneeFilter) {
    filter[TaskCenterTypes.FilterType_index.FILTER_BY_ASSIGNEE] = {
      locationId: locationIds,
      assignee: [assigneeFilter],
    };
  }

  return useGetTasksWithFilters(queryKeys, filter, sortType || undefined, {
    queryKeyHashFn: () => JSON.stringify({ filter, sortType, locationId: locationIds }),
  });
};
